import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { LoadingComponent } from './loading.component';
import { map, finalize  } from 'rxjs/operators';
import { Observable } from 'rxjs';

/**
 * Interceptor
 */
@Injectable()
export class Interceptor implements HttpInterceptor {
    /**
     * Interceptor
     * @description Listens for all HTTP requests and loads/unloads the Loading Spinner
     * @returns It returns an observable
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        LoadingComponent.setStatus(true);
        return next.handle(req).pipe(
            finalize(() => LoadingComponent.setStatus(false))
        );

    }
}
